import { LightBulb } from 'src/shared/design-system/Icon';
import { VerticallyCenteredText } from 'src/shared/design-system/VerticallyCenteredText';
import styled, { css } from 'styled-components';
import { Border, Colors, Font, Mixins, Spacing, Transition } from 'web-common/src/shared/styles';

export const Icon = LightBulb;

export const Container = styled.div`
  background: ${Colors.GRAY_LITE_30};
  border-radius: ${Border.Radius.M};
  display: flex;
  flex-direction: column;
  gap: ${Spacing.HALF};
  padding: ${Spacing.SINGLE};
  width: 100%;
`;

export const HeaderContainer = styled.div`
  color: ${Colors.GRAY_DARK_20};
  display: flex;
  align-items: center;
  gap: ${Spacing.HALF};

  & svg {
    ${Mixins.Shape.square(Spacing.SINGLE)}
  }
`;

export const Header = styled(VerticallyCenteredText)`
  margin: 0;
  ${Font.bySize(Font.Size.S, Font.Weight.SEMI_BOLD)}
`;

export const List = styled.ul`
  color: ${Colors.GRAY_DARK_10};
  padding: 0 ${Spacing.HALF} 0 ${Spacing.SINGLE_HALF};
  margin-bottom: 0;
  ${Font.bySize(Font.Size.S, Font.Weight.MEDIUM)}
`;

export const Line = styled.li<{ firstExpandableTipLine?: boolean }>`
  ${({ firstExpandableTipLine }) =>
    firstExpandableTipLine
      ? css`
          & button {
            margin-left: ${Spacing.QUARTER};
          }
        `
      : ``};
`;

export const ChildrenContainer = styled.div`
  color: ${Colors.GRAY_DARK_10};
  margin: 0;
  ${Font.bySize(Font.Size.S, Font.Weight.MEDIUM)}
`;

export const ExpandLink = styled.button<{ isHidden?: boolean }>`
  background: none;
  border: none;
  padding: 0;
  margin: 0;
  outline: 0;
  text-decoration: underline;
  transition: opacity ${Transition.Time.BASE};
  ${({ isHidden }) => css`
    opacity: ${isHidden ? '0' : '1'};
    max-height: ${isHidden ? '0' : Spacing.SINGLE_HALF};
  `}
`;
